import { commasToDots } from '../../../../helpers/adapters/custom'
import { isStringNumeric } from '../../../../helpers/validators'

export const rectangleSpongeCakeValidator = (
  length: string,
  width: string
): string[] => {
  const errors: string[] = []
  const L = commasToDots(length)
  const W = commasToDots(width)

  if (!isStringNumeric(L)) {
    errors.push('Wartość w polu "Długość foremki" nie jest wartością liczbową')
  }

  if (!isStringNumeric(W)) {
    errors.push(
      'Wartość w polu "Szerokość foremki" nie jest wartością liczbową'
    )
  }

  if (typeof parseFloat(L) === 'number' && parseFloat(L) <= 0) {
    errors.push('Wartość w polu "Długość tortu" musi być większa od 0')
  }

  if (typeof parseFloat(W) === 'number' && parseFloat(W) <= 0) {
    errors.push('Wartość w polu "Szerokość tortu" musi być większa od 0')
  }

  return errors
}
